// AUTO-GENERATED — DO NOT EDIT.
// Source: git commit dates of route source files.
// Regenerate: npm run seo:lastmod
// Generated: 2026-10-04 (commit c4c8587e8fda2c829eb829efff1eb394746bb212)

export const GENERATED_ROUTE_LAST_MODIFIED: Readonly<
  Record<string, string | null>
> = Object.freeze({
  '/english': '2026-10-05',
  '/english/g3': '2026-10-05',
  '/english/ip': '2026-10-05',
  '/english/ib': '2026-10-05',
  '/english/exam-format': '2026-10-05',
  '/chemistry': '2026-10-05',
  '/chemistry/pure-chemistry': '2026-10-05',
  '/chemistry/combined-science': '2026-10-05',
  '/chemistry/syllabus': '2026-10-05',
  '/': '2026-10-05',
  '/about-us': '2026-10-05',
  '/contact': '2026-09-07',
  '/terms': '2026-04-29',
  '/privacy': '2026-09-14',
  '/blog': '2026-08-13',
  '/primary-school': '2026-08-27',
  '/primary-1': '2026-08-27',
  '/primary-2': '2026-08-27',
  '/primary-3': '2026-08-27',
  '/primary-4': '2026-08-27',
  '/primary-5': '2026-08-27',
  '/primary-6': '2026-08-27',
  '/secondary-school': '2026-08-27',
  '/sec-1': '2026-08-27',
  '/sec-2': '2026-08-27',
  '/sec-3': '2026-08-27',
  '/sec-4': '2026-08-27',
  '/sec-1-g1': '2026-08-27',
  '/sec-1-g2': '2026-08-27',
  '/sec-1-g3': '2026-08-27',
  '/sec-1-ip': '2026-08-27',
  '/sec-2-g1': '2026-08-27',
  '/sec-2-g2': '2026-08-27',
  '/sec-2-g3': '2026-08-27',
  '/sec-2-ip': '2026-08-27',
  '/sec-3-g1': '2026-08-27',
  '/sec-3-g2': '2026-08-27',
  '/sec-3-g3': '2026-08-27',
  '/sec-3-ip': '2026-08-27',
  '/sec-4-g1': '2026-08-27',
  '/sec-4-g2': '2026-08-27',
  '/sec-4-g3': '2026-08-27',
  '/sec-4-ip': '2026-08-27',
  '/sec-1-ib': '2026-08-27',
  '/sec-2-ib': '2026-08-27',
  '/sec-3-ib': '2026-08-27',
  '/sec-4-ib': '2026-08-27',
  '/psle': '2026-08-27',
  '/o-level': '2026-08-27',
  '/n-level': '2026-08-27',
  '/e-math': '2026-08-27',
  '/a-math': '2026-08-27',
  '/integrated-programme': '2026-08-27',
  '/ib': '2026-08-27',
  '/online-math-tuition': '2026-08-14',
  '/online-psle-math-tuition': '2026-08-27',
  '/online-o-level-math-tuition': '2026-08-14',
  '/online-secondary-math-tuition': '2026-08-14',
  '/online-or-in-person-math-tuition-singapore': '2026-08-04',
  '/online-math-tuition-options-singapore': '2026-08-04',
  '/psle-math-practice': '2026-08-27',
  '/secondary-math-syllabus': '2026-08-14',
  '/primary-math-syllabus': '2026-08-27',
  '/demo/practice': '2026-09-12',
  '/demo/analytics': '2026-09-12',
  '/schools/__shared__': '2026-09-18',
  '/math-tuition/__shared__': '2026-09-06',
  '/partnerships/__shared__': '2026-09-06',
});
